import axios from 'axios';
import { urls } from '../config';
// import { useParams } from 'react-router-dom';
import { contextApp } from 'context';

export const useApiAuths = (param, token) => {
 //  const { company } = useParams();
 const { auth } = contextApp();

 const AuthApi = axios.create({
  baseURL: urls.auths([param]),
  headers: { 'x-access-token': token ?? auth?.token }
 });

 const signup = async credentials => (await AuthApi.post('/', credentials)).data;

 const signin = async credentials => (await AuthApi.post('/', credentials)).data;

 const validate = async (change = false) => (await AuthApi.get(`/${change ? 'change' : ''}`)).data;

 const validToken = async (change = false) => (await AuthApi.get(`/${change ? 'change' : ''}`)).data;

 const logout = async () => (await AuthApi.get('/')).data;

 const googlesignup = async tokenGoogle => (await AuthApi.post('/', tokenGoogle)).data;

 return { signup, signin, validate, validToken, googlesignup, logout };
};

/* loginGoogle */
export const loginGoogle = async data => {
 const url = urls.auth.googlelogin;
 const auth = await axios.post(url, data);
 console.log(auth.data);
 return auth.data;
};
/* loginFacebook */
export const loginFacebook = async (accessToken, userID) => {
 const url = urls.auth.facebooklogin;
 const auth = await axios.post(url, { accessToken, userID });
 localStorage.setItem('sesion', JSON.stringify(auth.data));
 return auth.data;
};

/* **********************signup****************

Este código es una función que se exporta y se llama "signup". La función toma un argumento "data", que es un objeto que contiene los datos necesarios para registrar un usuario en una aplicación.
Dentro de la función, primero se define una variable llamada "url" y se la iguala a "urls.auth.signup". Este objeto "urls" es importado desde otro archivo y contiene una serie de direcciones URL que se utilizan en la aplicación. La variable "url" es igual a la dirección URL para registrar un usuario.
A continuación, se utiliza la librería axios para hacer una solicitud HTTP "post" a la dirección URL definida. La solicitud toma dos argumentos: la dirección URL y el objeto "data" que se pasó a la función.
Finalmente, la respuesta a la solicitud se almacena en la variable "auth", y se devuelve la propiedad "data" de la respuesta, que contiene la información devuelta por el servidor.
 */
/* export const signup = async data => {
 const url = urls.auth.signup;
 const auth = await axios.post(url, data);
 return auth.data;
}; */
/*                        *********signupGoogle************
 La función toma un argumento llamado "data" y hace una llamada HTTP a una URL usando la librería Axios. La URL se obtiene de la constante "urls.auth.googlesignup" que es una parte de un objeto de configuración de la aplicación.

*/
export const signupGoogle = async data => {
 const url = urls.auth.googlesignup;
 const auth = await axios.post(url, data);
 localStorage.setItem('sesion', JSON.stringify(auth.data));
 console.log(auth.data);
 return auth.data;
};
/* La función luego toma la respuesta de la llamada HTTP y almacena la información de autenticación en el localStorage del navegador con la clave "sesion". Finalmente, la función devuelve la información de autenticación. */

/* 
                    ********** signupFacebook*********
Este código es una función llamada "signupFacebook" que permite al usuario registrarse en la aplicación utilizando su cuenta de Facebook. La función toma dos parámetros: "accessToken" y "userID". */
export const signupFacebook = async (accessToken, userID) => {
 const url = urls.auth.facebooksignup;
 const auth = await axios.post(url, { accessToken, userID });
 localStorage.setItem('sesion', JSON.stringify(auth.data));
 return auth.data;
};
/* 
La primera línea establece la URL que se utilizará para la petición POST para registrarse en la aplicación. La URL se importa desde un archivo donde se definen todas las URL de la aplicación.

La siguiente línea utiliza la biblioteca Axios para realizar una petición POST a la URL especificada, pasando como parámetros "accessToken" y "userID". La respuesta de la petición se almacena en la variable "auth".

La siguiente línea utiliza el método "setItem" de localStorage para almacenar la respuesta en el almacenamiento local del navegador, en una clave llamada "sesión". La respuesta se convierte a una cadena JSON antes de ser almacenada.

Finalmente, la función devuelve la respuesta de la petición, que contiene los detalles de la sesión del usuario registrado. */

/*                        ***********Logout**********

Este código define una función llamada "Logout", la cual toma un parámetro "token". La función realiza una llamada a un endpoint utilizando Axios para cerrar la sesión actual del usuario. mas info debajo>>> */

/* 
La primera línea de la función elimina el elemento con clave "sesion" del localStorage. Esto es probablemente el token de acceso que se ha utilizado para autenticar al usuario en el sistema.
Después, se asigna la dirección URL del endpoint para cerrar sesión a una variable "url", la cual se define en el objeto "urls". Esta dirección se encuentra en el archivo donde se exportan todas las URL necesarias en la aplicación.
Luego, se crea un objeto "headers" que contiene un header "x-access-token" con el valor del token que se recibe como parámetro. Este header es necesario para autenticar la petición y garantizar que la acción se realice por el usuario correcto.
Por último, se hace una petición POST a la URL utilizando Axios, incluyendo los headers previamente definidos. La respuesta de la petición se guarda en una variable "auth", y la función devuelve la propiedad "data" de esta respuesta.
En resumen, esta función se encarga de cerrar la sesión actual del usuario, eliminando el token de acceso del localStorage y haciendo una petición POST al endpoint correspondiente para invalidar el token en el servidor.
 */

/* *****************passReset**************
La función acepta un objeto llamado "data" como argumento.
Dentro de la función, se asigna una URL a la constante "url" que es igual a la propiedad "reset" de la constante "urls.auth".
Después, se hace una llamada a una función PUT de Axios y se le pasa la URL, un objeto con la propiedad "newPassword" y un objeto de cabeceras que contiene el token como una propiedad.
La respuesta de la llamada a Axios se almacena en una constante llamada "auth".
Finalmente, la función devuelve la propiedad "data" de la respuesta de Axios, que se encuentra en la constante "auth".
 */
export const passReset = async data => {
 const url = urls.auth.reset;
 const auth = await axios.put(url, { newPassword: data.newPassword }, { headers: { token: data.token } });
 return auth.data;
};

export const passForgot = async data => {
 const url = urls.auth.forgot;
 const auth = await axios.put(url, data);
 return auth.data;
};

export default {
 //Auth,
 //login,
 //Logout,
 passReset,
 passForgot,
 //validToken,
 loginGoogle,
 loginFacebook
 //signup
};

/*                  ******************definicion GENERAL*************

Este código es un archivo de servicios de autenticación para una aplicación de React. Se importa la librería axios para hacer peticiones HTTP y se utiliza el hook useContext de React para acceder al contexto de la aplicación.
El archivo define varias funciones asíncronas que representan distintas operaciones de autenticación, como el inicio de sesión, el registro, la validación de un token y la recuperación de contraseña. Cada función hace una petición HTTP a una URL específica utilizando axios.
Por ejemplo, la función de inicio de sesión (login) toma las credenciales del usuario como argumento y hace una petición POST a la URL correspondiente, devolviendo los datos de autenticación en el caso de éxito. La función de validación de token (validToken) toma el token y la empresa como argumento y hace una petición POST para verificar si el token es válido.
Además, el archivo define también funciones de inicio de sesión y registro utilizando Google y Facebook. Estas funciones hacen peticiones POST a las URL correspondientes con los datos necesarios, y almacenan los datos de sesión en el almacenamiento local en caso de éxito.
Por último, el archivo exporta un objeto con todas las funciones de autenticación para su uso en otras partes de la aplicación.
 */
